import { useSite } from "../lib/SiteContext";
import { useEnquiry } from "../lib/EnquiryContext";
import Seo from "../components/Seo";
import FadeIn from "../components/FadeIn";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const Faq = () => {
  const { content } = useSite();
  const { openEnquiry } = useEnquiry();
  const faqs = content?.faqs || [];

  return (
    <div data-testid="faq-page">
      <Seo
        title="FAQ — Aloha Corfu Tours | Private Corfu Tour Questions"
        description="Answers about booking private Corfu tours: how enquiries work, prices on request, hotel pickup, private groups, flexible itineraries and more."
      />
      <section className="bg-pine-dark py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-seafoam">Good to know</p>
            <h1 className="mt-2 font-display text-4xl font-semibold text-white sm:text-5xl">Frequently Asked Questions</h1>
          </FadeIn>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <Accordion type="single" collapsible className="rounded-2xl border border-gray-100 bg-white px-5 shadow-soft" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`}>
                  <AccordionTrigger className="text-left text-sm font-semibold text-pine" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-gray-600" data-testid={`faq-content-${i}`}>{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeIn>
          <FadeIn className="mt-8 rounded-2xl bg-seafoam-light/60 p-6 text-center">
            <p className="font-display text-xl font-semibold text-pine">Still curious?</p>
            <p className="mt-1 text-sm text-gray-600">Ask us anything — we reply personally to every message.</p>
            <button onClick={() => openEnquiry()} data-testid="faq-enquire-button"
                    className="mt-4 rounded-full bg-pine px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-pine-light">
              Request a Tour
            </button>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default Faq;
